/** UtilityImports — standalone sidebar page for the UtilityAdmin: import students/teachers. */
import Layout from "@/components/Layout";
import { UploadCloud } from "lucide-react";
import AdminImports from "@/pages/AdminImports";

export default function UtilityImports() {
  return (
    <Layout>
      <div className="space-y-6" data-testid="utility-imports-page">
        <div className="flex items-center gap-3">
          <div className="h-11 w-11 rounded-xl bg-sky-50 dark:bg-sky-900/30 text-sky-600 dark:text-sky-300 flex items-center justify-center">
            <UploadCloud className="h-5 w-5" />
          </div>
          <div>
            <h1 className="text-2xl font-semibold text-slate-900 dark:text-slate-100" style={{ fontFamily: "Outfit" }}>Imports</h1>
            <p className="text-sm text-slate-500 dark:text-slate-400">Bulk-import students and teachers from a spreadsheet.</p>
          </div>
        </div>
        <AdminImports />
      </div>
    </Layout>
  );
}
